module.exports = __webpack_public_path__ + "img/no-store.e8f5a2e4.png";